      /*
        Free Install Package Logic
        - Automatically adds a specific "free install" product to the cart when any product
          with the "free-install" tag is added.
        - Automatically removes the "free install" product if the last qualifying product is removed from the cart.
        - Designed for modern Shopify themes like Dawn that use AJAX for cart updates.
      */
      (function() {
        'use strict';
      
        // --- CONFIGURATION ---
        // const INSTALL_PACKAGE_VARIANT_ID = 47075047342331; // <-- UPDATE with your "Free Install" product variant ID
        const INSTALL_PACKAGE_VARIANT_ID = 47183892545787; // <-- UPDATE with your "Free Install" product variant ID
        const QUALIFYING_TAG = "free-install";            // <-- UPDATE with your qualifying tag
      
        // Section Names (Verify these match your theme's section filenames in the /sections folder)
        const CART_PAGE_SECTION_ID = "main-cart-items";    // Used for ?section_id= on the cart page
        const CART_DRAWER_SECTION_NAME = "cart-drawer";      // Used for /?sections=
        const CART_ICON_BUBBLE_SECTION_NAME = "cart-icon-bubble"; // Used for /?sections=
      
        if (!INSTALL_PACKAGE_VARIANT_ID || !QUALIFYING_TAG) {
          console.error("Free Install Script: Configuration missing (INSTALL_PACKAGE_VARIANT_ID or QUALIFYING_TAG).");
          return;
        }
      
        // --- CART UTILITIES ---
        async function getCart() {
          try {
            const res = await fetch("/cart.js");
            if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
            return await res.json();
          } catch (error) {
            console.error("Free Install Script (getCart):", error);
            return null;
          }
        }
      
        async function getProductTags(handle) {
          if (!handle) return [];
          try {
            if (!window.productTagCache) window.productTagCache = {};
            if (window.productTagCache[handle]) return window.productTagCache[handle];
      
            const res = await fetch(`/products/${handle}.js`);
            if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);
            const product = await res.json();
            const tags = product.product?.tags || product.tags || [];
            window.productTagCache[handle] = tags;
            return tags;
          } catch (error) {
            console.warn(`Free Install Script (getProductTags for ${handle}):`, error);
            return [];
          }
        }
      
        async function productHasFreeInstallTag(handle) {
          const tags = await getProductTags(handle);
          return tags.includes(QUALIFYING_TAG);
        }
      
        // --- UI & CART STATE MANAGEMENT ---
      
        let isRefreshing = false;
        async function refreshCartView() {
          if (isRefreshing) return;
          isRefreshing = true;
          console.log("Free Install Script: Refreshing cart view...");
      
          try {
            const isCartPage = window.location.pathname.includes("/cart");
      
            if (isCartPage) {
              const sectionWrapperId = `shopify-section-${CART_PAGE_SECTION_ID}`;
              const currentCartSectionWrapper = document.getElementById(sectionWrapperId);
              const currentCartItemsDirect = document.getElementById(CART_PAGE_SECTION_ID);

              let targetElementForUpdate;
              if (currentCartSectionWrapper) {
                  targetElementForUpdate = currentCartSectionWrapper;
              } else if (currentCartItemsDirect) {
                  targetElementForUpdate = currentCartItemsDirect;
              }

              if (targetElementForUpdate) {
                const res = await fetch(window.location.pathname + `?section_id=${CART_PAGE_SECTION_ID}`);
                if (!res.ok) throw new Error(`Failed to fetch cart section '${CART_PAGE_SECTION_ID}': ${res.status}`);
                const html = await res.text();
                const newDoc = new DOMParser().parseFromString(html, "text/html");
                
                // Try to find the new content based on how we found the current one
                const newContentWrapper = newDoc.getElementById(sectionWrapperId);
                const newContentDirect = newDoc.getElementById(CART_PAGE_SECTION_ID);
                let newHTMLContentSource;

                if (currentCartSectionWrapper && newContentWrapper) { // Updating wrapper with wrapper
                    newHTMLContentSource = newContentWrapper;
                } else if (currentCartItemsDirect && newContentDirect) { // Updating direct element with direct element
                     newHTMLContentSource = newContentDirect;
                } else if (currentCartItemsDirect && newContentWrapper && newContentWrapper.querySelector(`#${CART_PAGE_SECTION_ID}`)) { // current is direct, new has wrapper
                    newHTMLContentSource = newContentWrapper.querySelector(`#${CART_PAGE_SECTION_ID}`);
                } else if (currentCartSectionWrapper && newContentDirect && targetElementForUpdate.querySelector(`#${CART_PAGE_SECTION_ID}`)) { // current is wrapper, new is direct
                    // This case is tricky, better to replace innerHTML of current target with new direct content.
                    targetElementForUpdate.querySelector(`#${CART_PAGE_SECTION_ID}`).innerHTML = newContentDirect.innerHTML;
                    console.log(`Free Install Script: Cart page section '${CART_PAGE_SECTION_ID}' (inner) refreshed.`);
                } else {
                    // Fallback: try to use the first successfully parsed new content.
                    newHTMLContentSource = newContentWrapper || newContentDirect;
                }

                if (newHTMLContentSource && targetElementForUpdate !== newHTMLContentSource) { // Avoid replacing element with itself
                    targetElementForUpdate.innerHTML = newHTMLContentSource.innerHTML;
                    console.log(`Free Install Script: Cart page section targeting '${targetElementForUpdate.id}' refreshed.`);
                } else if (newHTMLContentSource && targetElementForUpdate === newHTMLContentSource) {
                     console.log(`Free Install Script: Cart page section already matches or source is target.`);
                } else {
                    console.warn(`Free Install Script: Could not find matching new content for '${CART_PAGE_SECTION_ID}' to refresh. Reloading page.`);
                    window.location.reload();
                }
              } else {
                console.warn(`Free Install Script: Could not find current cart element ('#${sectionWrapperId}' or '#${CART_PAGE_SECTION_ID}') to refresh. Reloading page.`);
                window.location.reload();
              }
            } else {
              // For the cart drawer
              const sectionsToFetch = [CART_DRAWER_SECTION_NAME, CART_ICON_BUBBLE_SECTION_NAME].filter(Boolean).join(',');
              if (!sectionsToFetch) {
                  console.warn("Free Install Script: No drawer/bubble section names configured for refresh.");
                  isRefreshing = false; return;
              }
      
              const res = await fetch(`/?sections=${sectionsToFetch}`);
              if (!res.ok) throw new Error(`Failed to fetch drawer sections '${sectionsToFetch}': ${res.status}`);
              
              const contentType = res.headers.get("content-type");
              if (!contentType || !contentType.includes("application/json")) {
                  const responseText = await res.text();
                  throw new Error(`Unexpected content type for sections API. Expected JSON, got ${contentType}. Response: ${responseText}`);
              }
              
              const parsedState = await res.json();
      
              if (!parsedState || typeof parsedState !== 'object' || Object.keys(parsedState).length === 0) {
                  console.warn("Free Install Script: Parsed state from sections API is not a valid object or is empty.", parsedState);
                  isRefreshing = false; return;
              }
      
              const cartDrawerElement = document.querySelector("cart-drawer"); 
              const cartDrawerHTML = parsedState[CART_DRAWER_SECTION_NAME];
      
              if (cartDrawerElement && typeof cartDrawerElement.renderContents === 'function' && cartDrawerHTML) {
                let payloadForRender = { sections: {} };
                payloadForRender.sections[CART_DRAWER_SECTION_NAME] = cartDrawerHTML;
                if (parsedState[CART_ICON_BUBBLE_SECTION_NAME]) {
                  payloadForRender.sections[CART_ICON_BUBBLE_SECTION_NAME] = parsedState[CART_ICON_BUBBLE_SECTION_NAME];
                }
                cartDrawerElement.renderContents(payloadForRender);
                console.log(`Free Install Script: Cart drawer '${CART_DRAWER_SECTION_NAME}' refreshed via renderContents.`);
              } else if (cartDrawerHTML) {
                const drawerById = document.getElementById(CART_DRAWER_SECTION_NAME);
                if (drawerById) {
                  drawerById.innerHTML = cartDrawerHTML;
                  console.log(`Free Install Script: Cart drawer '${CART_DRAWER_SECTION_NAME}' refreshed via innerHTML by ID.`);
                } else if (cartDrawerElement) {
                    console.warn(`Free Install Script: cart-drawer.renderContents not available or no element with ID '${CART_DRAWER_SECTION_NAME}'. Attempting innerHTML on <cart-drawer>.`);
                    cartDrawerElement.innerHTML = new DOMParser().parseFromString(cartDrawerHTML, "text/html").body.innerHTML;
                } else {
                  console.warn(`Free Install Script: Cart drawer element (<cart-drawer> or #${CART_DRAWER_SECTION_NAME}) not found, or renderContents unavailable, or cartDrawerHTML missing.`);
                }
              } else if (parsedState && CART_DRAWER_SECTION_NAME && !cartDrawerHTML) {
                  console.warn(`Free Install Script: Section HTML for '${CART_DRAWER_SECTION_NAME}' not found in API response. Available sections:`, Object.keys(parsedState));
              }
      
              const cartIconBubbleElement = document.querySelector("cart-icon-bubble");
              const cartIconBubbleHTML = parsedState[CART_ICON_BUBBLE_SECTION_NAME];
      
              if (cartIconBubbleElement && cartIconBubbleHTML) {
                cartIconBubbleElement.innerHTML = new DOMParser().parseFromString(cartIconBubbleHTML, "text/html").body.innerHTML;
                console.log(`Free Install Script: Cart icon bubble '${CART_ICON_BUBBLE_SECTION_NAME}' refreshed.`);
              } else if (parsedState && CART_ICON_BUBBLE_SECTION_NAME && !cartIconBubbleHTML) {
                  console.warn(`Free Install Script: Section HTML for '${CART_ICON_BUBBLE_SECTION_NAME}' not found in API response. Available sections:`, Object.keys(parsedState));
              } else if (CART_ICON_BUBBLE_SECTION_NAME && !cartIconBubbleElement) {
                  console.warn(`Free Install Script: cart-icon-bubble element not found for section '${CART_ICON_BUBBLE_SECTION_NAME}'.`);
              }
            }
          } catch (error) {
            console.error("Free Install Script (refreshCartView):", error);
          } finally {
            setTimeout(() => { 
              isRefreshing = false; 
              console.log("Free Install Script: Refresh flag reset."); 
            }, 250);
          }
        }
      
        // --- CORE LOGIC ---
        async function syncFreeInstallPackage() {
          console.log("Free Install Script: Starting syncFreeInstallPackage.");
          const cart = await getCart();
          if (!cart) {
            console.error("Free Install Script (syncFreeInstallPackage): Failed to get cart, aborting sync.");
            return false; 
          }
      
          let hasQualifyingItem = false;
          const itemTagChecks = cart.items.map(async (item) => {
            if (item.variant_id === INSTALL_PACKAGE_VARIANT_ID) return false;
            if (item.handle) return await productHasFreeInstallTag(item.handle);
            return false;
          });
      
          const results = await Promise.all(itemTagChecks);
          hasQualifyingItem = results.some(isQualifying => isQualifying);
      
          const installItemInCart = cart.items.find(item => item.variant_id === INSTALL_PACKAGE_VARIANT_ID);
          let madeChange = false;
      
          if (installItemInCart && !hasQualifyingItem) {
            console.log(`Free Install Script: No qualifying items, but install package (ID: ${INSTALL_PACKAGE_VARIANT_ID}, Key: ${installItemInCart.key}) in cart. Preparing to remove.`);
            try {
                if (!installItemInCart.key) {
                    console.error("Free Install Script: Cannot remove install package, item key is missing from cart data.", installItemInCart);
                    throw new Error("Install package item key is missing.");
                }

                const changeResponse = await fetch("/cart/change.js", {
                    method: "POST",
                    headers: { 
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    },
                    body: JSON.stringify({ id: installItemInCart.key, quantity: 0 }), 
                });

                const responseText = await changeResponse.text(); // Get text first for debugging
                let responseData;
                try {
                    responseData = JSON.parse(responseText);
                } catch (e) {
                    // If parsing fails but response is OK, it might be an empty string or non-JSON success
                    if (changeResponse.ok) {
                        console.warn("Free Install Script: /cart/change.js response was not valid JSON, though status was OK. Response Text:", responseText);
                        responseData = { success: true, raw: responseText }; // Assume success
                    } else {
                        // If not OK and not JSON, create an error object
                        responseData = { 
                            message: "Non-JSON error response", 
                            description: responseText.substring(0, 200), // Log snippet
                            status: changeResponse.status 
                        };
                    }
                }
                
                if (!changeResponse.ok) {
                    console.error("Free Install Script: API call to /cart/change.js FAILED.", {
                        status: changeResponse.status,
                        statusText: changeResponse.statusText,
                        requestKey: installItemInCart.key,
                        response: responseData
                    });
                    // This error will be caught by the catch block below
                    throw new Error(`Failed to remove install package: ${responseData.description || responseData.message || changeResponse.statusText}`);
                }
                
                // Even if changeResponse.ok, check if Shopify's JSON body indicates an error (e.g., 422s can sometimes be wrapped in 200 OK with error in body)
                if (responseData && (responseData.status >= 400 || responseData.message || responseData.description && !responseData.items)) { // Check for error indicators or missing cart items array
                     if(responseData.items && responseData.items.length >= 0 && responseData.status === undefined && responseData.message === undefined) {
                        // Looks like a valid cart response, not an error
                        console.log("Free Install Script: Install package removal request successful (parsed as cart). Response:", responseData);
                     } else {
                        console.error("Free Install Script: API call to /cart/change.js returned OK status but response body indicates an error or is not a cart object.", responseData);
                        throw new Error(`Failed to remove install package (error in response body): ${responseData.description || responseData.message || "Unknown error in response"}`);
                     }
                } else {
                     console.log("Free Install Script: Install package removal request successful. Response:", responseData);
                }
                madeChange = true;

            } catch (error) {
                console.error("Free Install Script (syncFreeInstallPackage - remove operation error):", error.message);
                // madeChange remains false. The theme's generic error message might be shown.
            }
          }
          console.log(`Free Install Script: Sync check complete. HasQualifying: ${hasQualifyingItem}, InstallInCart: ${!!installItemInCart}, MadeChange: ${madeChange}`);
          return madeChange;
        }
      
        // --- EVENT LISTENERS ---
         document.querySelectorAll("form[action='/cart/add']").forEach((form) => {
            form.addEventListener("submit", async (e) => {
              // We DO NOT call e.preventDefault().
              // We let the theme's own JavaScript handle the submission and add the main product.
              // Our script will only react if the product is a qualifying one.

              // First, let's figure out if the product being added qualifies for the free install.
              let productHandle = form.dataset.productHandle;
              if (!productHandle) {
                  const productPageUrl = form.closest('[data-product-url]')?.dataset.productUrl;
                  if (productPageUrl) {
                      const match = productPageUrl.match(/\/products\/([^/?#]+)/);
                      if (match) productHandle = match[1];
                  }
              }
              if (!productHandle) {
                const pathParts = window.location.pathname.split("/products/");
                if (pathParts.length > 1) productHandle = pathParts[1].split("/")[0];
              }
              
              if (!productHandle) {
                  console.log("Free Install Script: Could not determine product handle on submit. Aborting free install check.");
                  return; // Exit if we can't identify the product.
              }

              const qualifies = await productHasFreeInstallTag(productHandle);

              // If the product does NOT qualify, we do nothing at all.
              if (!qualifies) {
                console.log(`Free Install Script: Product (${productHandle}) does not qualify. Letting theme handle the add normally.`);
                return;
              }

              // If the product DOES qualify, we wait a short moment for the theme's AJAX to complete.
              console.log(`Free Install Script: Product (${productHandle}) qualifies. Will add install package after a short delay.`);
              
              setTimeout(async () => {
                try {
                  const cart = await getCart();
                  // Check if the install package is already there before adding it.
                  if (cart && !cart.items.some(item => item.variant_id === INSTALL_PACKAGE_VARIANT_ID)) {
                    console.log(`Free Install Script: Adding install package (ID: ${INSTALL_PACKAGE_VARIANT_ID}).`);
                    
                    const installAddResponse = await fetch("/cart/add.js", {
                      method: "POST",
                      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
                      body: JSON.stringify({ id: INSTALL_PACKAGE_VARIANT_ID, quantity: 1 }),
                    });
                    
                    const responseJson = await installAddResponse.json();
                    if (!installAddResponse.ok) {
                      throw new Error(responseJson.description || "Failed to add install package.");
                    }
                    console.log("Free Install Script: Install package added successfully.");
                  } else {
                    console.log("Free Install Script: Install package already in cart or cart data unavailable. No action needed.");
                  }

                  // After potentially adding the item, refresh the cart view to show everything.
                  await refreshCartView();

                } catch (error) {
                  console.error("Free Install Script (Delayed Add Error):", error.message);
                }
              }, 750); // A 750ms delay is usually enough for the theme's add-to-cart to finish.
            });
          });
      
        function onCartChange() {
          if (isRefreshing) {
            console.log("Free Install Script: Cart change detected during refresh, skipping sync.");
            return;
          }
          console.log("Free Install Script: Cart change detected by observer. Scheduling sync.");
          setTimeout(async () => {
            if (isRefreshing) {
                console.log("Free Install Script: Refresh started during sync timeout, skipping sync.");
                return;
            }
            console.log("Free Install Script: Running scheduled syncFreeInstallPackage.");
            const wasAdjusted = await syncFreeInstallPackage();
            if (wasAdjusted) {
              console.log("Free Install Script: Install package was adjusted by sync. Refreshing view.");
              await refreshCartView();
            } else {
              console.log("Free Install Script: Install package not adjusted by sync after cart change (or sync failed).");
            }
          }, 500); // Slightly increased delay
        }
      
        function setupObserver(targetNode, nodeNameForLog) {
          if (!targetNode) {
              console.warn(`Free Install Script: Observer target node '${nodeNameForLog}' not found.`);
              return null;
          }
          const observer = new MutationObserver((mutationsList) => {
            if (isRefreshing) return;
            for (const mutation of mutationsList) {
              if (mutation.type === 'childList' || mutation.type === 'subtree') {
                onCartChange();
                return; 
              }
            }
          });
          observer.observe(targetNode, { childList: true, subtree: true });
          console.log(`Free Install Script: MutationObserver attached to ${nodeNameForLog} (Element: ${targetNode.tagName}${targetNode.id ? '#' + targetNode.id : ''}${targetNode.className ? '.' + targetNode.className.split(' ').join('.') : ''}).`);
          return observer;
        }
      
        document.addEventListener('DOMContentLoaded', () => {
          const cartPageSectionWrapper = document.getElementById(`shopify-section-${CART_PAGE_SECTION_ID}`);
          const cartPageDirect = document.getElementById(CART_PAGE_SECTION_ID);
          setupObserver(cartPageSectionWrapper || cartPageDirect, `cart page container (tried #shopify-section-${CART_PAGE_SECTION_ID} then #${CART_PAGE_SECTION_ID})`);
          
          const cartDrawerNode = document.querySelector('cart-drawer');
          if (cartDrawerNode) {
              setupObserver(cartDrawerNode, 'cart-drawer element');
          } else {
              const cartDrawerById = document.getElementById(CART_DRAWER_SECTION_NAME);
              if (cartDrawerById) {
                  setupObserver(cartDrawerById, `cart drawer by ID (#${CART_DRAWER_SECTION_NAME})`);
              } else {
                  console.warn(`Free Install Script: Neither <cart-drawer> nor #${CART_DRAWER_SECTION_NAME} found for MutationObserver.`);
              }
          }
      
          if (window.location.pathname.includes("/cart")) {
             setTimeout(async () => {
                console.log("Free Install Script: Initial sync on cart page load.");
                if (isRefreshing) return;
                const wasAdjusted = await syncFreeInstallPackage();
                if (wasAdjusted) {
                  await refreshCartView();
                }
             }, 700);
          }
          console.log("Free Install Script: DOMContentLoaded setup complete.");
        });
      
        console.log("Free Install Script Loaded.");
      })();